import get from 'lodash/get';
import {
  getDocumentFields,
  getImage,
} from 'utils/helper';

export default ({
  introSection,
  section,
  type,
  handleOnCTAClick,
}) => {
  const {
    title,
    description,
    formattedDescription,
    subtitle,
    images,
    contentModules,
  } = getDocumentFields(
    section,
    [
      'title',
      'description',
      'images',
      'contentModules',
      'formattedDescription',
      'subtitle',
    ],
  );
  const image = getImage(get(images, '[0]', {}));

  const figuresData = contentModules?.find((module) => {
    const { contentModules: figures } = getDocumentFields(module, ['contentModules']);

    return figures;
  });

  const { imagesBundles } = getDocumentFields(
    contentModules?.[0],
    ['imagesBundles'],
  );

  const links = contentModules?.filter((module) => {
    const {
      type: linkType,
    } = getDocumentFields(module, [
      'type',
    ]);

    return linkType === 'button' || linkType === 'scroll-to-section';
  });

  const ctaLinks = contentModules?.filter((module) => {
    const {
      type: linkType,
    } = getDocumentFields(module, [
      'type',
    ]);

    return linkType === 'scroll-block';
  });

  return {
    type,
    introSection,
    title,
    description,
    formattedDescription,
    subtitle,
    image,
    imagesBundles,
    figuresData,
    handleOnCTAClick,
    links,
    ctaLinks,
  };
};
